


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";


const RejectionFormApmc = () => {
    const [selectedAction, setSelectedAction] = useState("All");
     const language = useSelector((state:any)=>state.auth.language);
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
    
      
    const rolePriorityMap: Record<string, string> = {
        JC: "dclerkAfterRejectionAction",
        COM: "dclerkAfterRejectionAction",
        Dr: "dclerkAfterRejectionAction",
        SC:"hoclerkAfterRejectionAction",
        HOS:"hoclerkAfterRejectionAction",
        DY:"hoclerkAfterRejectionAction",
        DT:"hoclerkAfterRejectionAction",

      };

    const statusOptions = [
         { value: "all_raiseQuery", label: "All Application" ,  role:["JC" , "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
        { value: "dclerkAfterHORejectionAction", label: "  Query Raised by HO Department" ,  role:["JC" ] },
        { value: "dclerkAfterRejectionAction", label: " Query Raised by Registrar" ,  role:["JC" , "COM" , "Dr", "SC" , "HOS" , "DY", "DT","SA"] },
        //   { value: "pendingAtDrAfterHoRaiseQuery", label: "Pending  Dist. Registrar after HO raise query", role:[ "Dr"] },    
         { value: "pendingAtDrAfterHoRaiseQuery", label: " Query Raised by HO Department" ,  role:[ "Dr", ] }, 
        { value: "hoclerkAfterRejectionAction", label: "Query Raised by Director and Deputy Director" ,  role:["SC" , "HOS" , "DY", "DT","SA"]  },
    ];

       // Filter options for current role
       const filteredOptions = statusOptions.filter(option => option.role.includes(roleIdentifier));

       const firstOptionValue = rolePriorityMap[roleIdentifier] || filteredOptions[0].value;
       
       // Reorder the options to place the matched option first
       const reorderedStatusOptions = [
         filteredOptions.find(option => option.value === firstOptionValue),
         ...filteredOptions.filter(option => option.value !== firstOptionValue)
       ].filter(Boolean); 


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable 
                            status={reorderedStatusOptions}
                            navigateTo="/forms-query-district" />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default RejectionFormApmc;
